<button (click) = "Test()"></button>

<div class = "form-group row">

    <label class = "col-sm-5 col-form-label">Casual Leaves to be cashed</label>
    <div class = "col-sm-4">
        <input type = "number" class = "form-control"
        [(ngModel)] = noOfCashLeaves
            placeholder = "0">
    </div>

</div>

<div>
    <button
        (click) = "CashLeaves()"
        class = "float-right m-1 btn btn-outline-success"> Cash Leaves
    </button>
</div>